import { IProfileEntity, IUpdateProfileDto } from "../domains/profile/interfaces/profile-controls.interface";
import { Injectable } from "@angular/core";
import { GraphService } from "@app/kernel/graphql/services/graph.service";
import { first, map } from "rxjs";
import profileDatashape from "../domains/profile/datashapes/profile.datashape";
import { IUpdatePasswordResponse } from "../domains/profile/interfaces/update-password.interface";
import { IEmaileDto } from "../domains/profile/interfaces/update-email.interface";
import { IVerifyOtpDto } from "@app/applications/authentication/interfaces/verify-otp-controls.interface";

@Injectable({
  providedIn: "root",
})
export class ProfileService {
  constructor(private graphService: GraphService) {}
  deleteAccount() {
    return this.graphService.constructMutation("deleteMyAccount", {}, {}, ["code", "text"]).pipe(first());
  }

  getProfile(dataShape: string = profileDatashape) {
    return this.graphService.constructQuery<{ customerProfile: IProfileEntity }>([dataShape], "customerProfile").pipe(
      first(),
      map(res => res.data.customerProfile)
    );
  }

  updateMyPassword(passwords: { oldPassword: string; newPassword: string }) {
    return this.graphService
      .constructMutation<IUpdatePasswordResponse>("updateMyPassword", { input: "updateMyPasswordInput!" }, { input: passwords }, ["text", "code"])
      .pipe(
        first(),
        map(result => result.data)
      );
  }
  updateMyProfile(dto: IUpdateProfileDto) {
    return this.graphService
      .constructMutation<IUpdatePasswordResponse>("updateMyProfile", { input: "updateMyProfileInput!" }, { input: dto }, ["text", "code"])
      .pipe(
        first(),
        map(result => result.data)
      );
  }
  updateMyEmail(dto: IEmaileDto) {
    return this.graphService
      .constructMutation<IUpdatePasswordResponse>("updateEmail", { input: "updateEmailInput!" }, { input: dto }, ["text", "code"])
      .pipe(
        first(),
        map(result => result.data)
      );
  }

  verify2FA(dto: IVerifyOtpDto) {
    return this.graphService
      .constructMutation<IUpdatePasswordResponse>("confirmUpdateEmail", { otp: "String!" }, { otp: dto.otp }, ["text", "code"])
      .pipe(map(res => res.data));
  }
}
